import React, { useState } from 'react'
import styled from 'styled-components'
import { MenuEntry, MenuLink } from './MenuEntry'

const Container = styled.div``
const AccordionContent = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? `${200}px` : 0)};
  transition: 0.3s ease-out;
  border-color: ${({ isOpen }) => (isOpen ? 'rgba(133, 133, 133, 0.1)' : 'transparent')};

  background: linear-gradient(
    90deg,
    rgb(195, 194, 27, 30%) 0%,
    rgb(216, 233, 13, 73%) 0.01%,
    rgb(254, 223, 10, 73%) 100%
  );
  box-shadow: ${({ isOpen }) => (isOpen ? '-2px 2px 6px #2a5e6f' : 'none')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};

  overflow: hidden;

  & > div {
    padding-left: 20px;
    padding-top: 10px;
  }
`

const Accordion = ({ label, isActive, initialOpenState = false, children }) => {
  const [isOpen, setIsOpen] = useState(initialOpenState)

  const handleClick = () => {
    setIsOpen((prevState) => !prevState)
  }

  return (
    <Container>
      <MenuEntry key={label} className={isActive ? 'active' : ''} onClick={handleClick}>
        <MenuLink>{label}</MenuLink>
      </MenuEntry>
      <AccordionContent isOpen={isOpen}>
        <div>{children}</div>
      </AccordionContent>
    </Container>
  )
}

export default Accordion
